import { jsonApi } from '../jsonApi';

jsonApi.define('tms/web-tag', {
  id: null,
  name: '',
  timeout: 0,
  container_id: null,
  validated: null,
  order: null,
  disabled: true,
  template_id: null,
  updated_at: null,
  updater_name: '',
  template: {
    jsonApi: 'hasOne',
    type: 'tms/tag-template',
  },
  container: {
    jsonApi: 'hasOne',
    type: 'tms/web-containers',
  },
});
